import {Box, Container, Typography, useTheme} from "@mui/material";

export function AppFooter() {
  const theme = useTheme();
  
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: "auto",
        backgroundColor: 'white',
        color: theme.palette.text.secondary,
        bottom: 0,
        width: "100%",
      }}
    >
      <Container maxWidth={false}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2">
            © 2025 Paradis.ltd. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
